import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const thermogravimetricAnalysis = {
    jpath: ['spectra', 'thermogravimetricAnalysis'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default thermogravimetricAnalysis;
//# sourceMappingURL=thermogravimetricAnalysis.js.map